import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { DOMAnimations } from '../libs/dom'

gsap.registerPlugin(ScrollToPlugin)

class Info {
  constructor() {
    this.infoLine = document.querySelectorAll('.js-line__item')
    this.linksToInfo = document.querySelectorAll('.js-info__link > a')

    this.init()
  }

  init() {
    this.toggleInfo()
    this.toggleLine()
    this.changeUrl()
    this.openOnLoad()
  }

  changeUrl() {
    this.linksToInfo.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()

        const title = link.getAttribute('title')
        const url = link.getAttribute('href')

        const newUrl = `${url}?title=${title}`

        history.pushState({}, '', newUrl)
        location.reload()
      })
    })
  }

  openOnLoad() {
    this.params = new URLSearchParams(window.location.search)
    this.titleValue = this.params.get('title')

    if (this.titleValue) {
      const button = document.querySelector(`[data-info="${this.titleValue}"]`)
      const tab = document.querySelector(`[data-info-slug="${this.titleValue}"]`)
      button.classList.add('is-opened')
      DOMAnimations.slideToggle(tab)
      gsap.to(window, { duration: 0.7, scrollTo: { y: tab, offsetY: 120 }, ease: 'power2.out' })
    }
  }

  toggleInfo() {
    this.isTransitioning = false

    const buttons = document.querySelectorAll('.js-info__button')
    const contents = document.querySelectorAll('.js-info__content')

    buttons.forEach((button, i) => {
      button.addEventListener('click', async () => {
        console.log('click')

        const dataAttr = button.dataset
        const tab = document.querySelector(`[data-info-slug="${dataAttr.info}"]`)

        if (this.isTransitioning) return

        buttons.forEach((b, itr) => b.classList.toggle('is-opened', itr === i))

        this.isTransitioning = true
        const promises = []

        contents.forEach((content, itr) => {
          const func = itr === i ? 'slideDown' : 'slideUp'
          promises.push(DOMAnimations[func](content))
        })

        await Promise.all(promises)
        this.isTransitioning = false

        gsap.to(window, { duration: 0.7, scrollTo: { y: tab, offsetY: 120 }, ease: 'power2.out' })
      })
    })
  }

  toggleLine() {
    this.infoLine.forEach((item) => {
      const button = item.querySelector('.js-line__button')
      const content = item.querySelector('.js-line__content')

      button.addEventListener('click', () => {
        item.classList.toggle('is-opened')
        DOMAnimations.slideToggle(content)
      })
    })
  }
}

export default Info
